import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { ToasterService } from '../../services/toaster.service';
import { UserService } from 'src/app/core/Services/user.service';
import { FormControl, FormGroup } from '@angular/forms';
import { CustomValidation } from '../../validators/customValidators';
import { UserDetails, UserProfile } from 'src/app/core/Models/interfaces/user-details';
import { SUB_TYPE, USER_TYPE } from 'src/app/core/Constants/static';
import { PrescriptionService } from 'src/app/features/prescription/prescription.service';
import { TransactionListByClient } from 'src/app/core/Models/interfaces/responseData';
import { AuthorizationsService } from 'src/app/features/authorization/services/authorizations.service';
import { UtilityService } from 'src/app/core/Services/utility.service';
import { ColumnSortObj } from 'src/app/core/Models/interfaces/columnSort';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-rad-lab-common-list',
  templateUrl: './rad-lab-common-list.component.html',
  styleUrls: ['./rad-lab-common-list.component.css']
})
export class RadLabCommonListComponent implements OnInit {

  prescriptionFilterForm !: FormGroup;
  @ViewChildren('focusedElement') focusedElement!: QueryList<any>;
  @ViewChild('advancedFilter') advancedFilter!: ElementRef;
  @Output() viewPop:EventEmitter<{
    showPrescriptionDetails: boolean,
    batchId: number,
    requestBatchId: number|null
  }> = new EventEmitter();
  @Input('exportVar') exportVar !: number;
  @Input('Type') componentType!: string;

  user?: UserDetails;
  showAdvancedFilter: boolean = false;
  page_limit = 10;
  page_no = 1;
  sortParams: string = '';
  public subTypes = SUB_TYPE;
  public subTypeEvm = environment?.subscriberType ? environment?.subscriberType : this.subTypes.both;
  statusArray: { id: string, name: string }[] = [
    {
      id: '1',
      name: 'Approved'
    },
    {
      id: '0',
      name: 'Rejected'
    },
    {
      id: '2',
      name: 'Partially Approved'
    },
    {
      id: '3',
      name: 'Cancelled'
    }
  ];
  statusArrayOnAuth: { id: string, name: string }[] = [
    {
      id: '0',
      name: 'Rejected'
    },
    {
      id: '2',
      name: 'Partially Approved'
    },
    {
      id: '3',
      name: 'Cancelled'
    }
  ];
  columnSort: ColumnSortObj = {
    requestId: {
      sortType: 'ascending',
    },
    senderId: {
      sortType: 'ascending',
    },
    receiverId: {
      sortType: 'ascending',
    },
    transactionDate: {
      sortType: 'ascending',
    },
    payerId: {
      sortType: 'ascending',
    },
    memberId: {
      sortType: 'ascending',
    },
    eHealthId: {
      sortType: 'ascending',
    },
    documentID: {
      sortType: 'ascending',
    },
    visitedOn: {
      sortType: 'ascending',
    },
    providerId: {
      sortType: 'ascending',
    },
  };
  fetchingInProgress: boolean = false;
  transactionListByClient: TransactionListByClient[] = [];
  totalCount!: number;
  showNavigation = false;
  isInsideAdvacedContainer = true;
  advFilter = false;

  constructor(
    private toasterandLoader: ToasterService,
    private userService: UserService,
    private prescriptionService: PrescriptionService,
    private authorizationService: AuthorizationsService,
    private utility: UtilityService

  ) {
    this.user = userService.getUserInfo()?.userDetails;
    this.prescriptionFilterForm = new FormGroup({
      requestId: new FormControl(null),
      senderId: new FormControl(null),
      receiverId: new FormControl(null),
      payerId: new FormControl(null),
      memberId: new FormControl(null),
      documentID: new FormControl(null),
      status: new FormControl(null),
      healthId: new FormControl(null),
      prescriptionId: new FormControl(null),
      providerId: new FormControl(null),
      isOverriden: new FormControl(null),
    }, CustomValidation.formNotNull);
  }

  @HostListener('document:click', ['$event'])
  clickOutSideAdvancedContainer(event: any) {
      if (!this.isInsideAdvacedContainer && !this.advancedFilter?.nativeElement.contains(event.target as Node)) {
          this.showAdvancedFilter = false;
      }
      this.isInsideAdvacedContainer = false;
  }


  public ngOnInit(): void {
    if (this.componentType.toLocaleUpperCase() === 'AUTH_LAB' || this.componentType.toLocaleUpperCase() === 'AUTH_RAD') {
      this.statusArray = [
        {
          id: '0',
          name: 'Rejected'
        },
        {
          id: '2',
          name: 'Partially Approved'
        }
      ]
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['exportVar']?.currentValue) {
      if (this.exportVar !== 0) {
        this.Export();
      }
    }
  }

  public selectedValue(event: string | null, formElem: string): void {
    if (!event) {
      this.prescriptionFilterForm.controls[formElem].patchValue(null);
    }
    this.prescriptionFilterForm.controls[formElem].patchValue(event);
  }

  public userTypeListing(): void {
    let filterPayload = {
      per_page: this.page_limit,
      page: this.page_no,
      sort: this.sortParams,
      requestId: this.prescriptionFilterForm?.value?.requestId || '',
      senderId: this.prescriptionFilterForm?.value?.senderId || '',
      receiverId: this.prescriptionFilterForm?.value?.receiverId || '',
      payerId: this.prescriptionFilterForm?.value?.payerId || '',
      memberId: this.prescriptionFilterForm?.value?.memberId || '',
      facilityId: this.prescriptionFilterForm?.value?.documentID || '',
      healthId: this.prescriptionFilterForm?.value?.healthId || '',
      prescriptionId: this.prescriptionFilterForm?.value?.prescriptionId || '',
      providerId: this.prescriptionFilterForm?.value?.providerId || '',
      approvalStatus: this.prescriptionFilterForm?.value?.status || '',
      isOverriden: this.prescriptionFilterForm?.value?.isOverriden ? '1' : '',
    }
    if (this.user?.userType === USER_TYPE.system && (this.checkPermission('getAllTransaction') || this.checkPermission('getTransactionClientPreApproval'))) {
      this.getTransactionListByClient(filterPayload);
    }
    this.showAdvancedFilter = false;
    this.isInsideAdvacedContainer = false;
  }

  public sortColumn(colName: string): void {
    for (const key in this.columnSort) {
      if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
        if (key == colName) {
          this.columnSort[colName].clicked = true;
          this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
          this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
          this.page_no = 1;
          this.userTypeListing();
        } else {
          this.columnSort[key].sortType = 'ascending';
        }

      }
    }
  }
  
  public checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

  // this.checkPermission('getTransactionClientLabPreApproval, getTransactionClientRadPreApproval')
  public getTransactionListByClient(filterPayload: Record<string, string | number | null>): void {
    if (this.componentType.toLocaleUpperCase() === 'PRE_RAD') {
      this.preRadApiCall(filterPayload);
    }
    else if (this.componentType.toLocaleUpperCase() === 'PRE_LAB') {
      this.preLabApiCall(filterPayload);
    }
    else if (this.componentType.toLocaleUpperCase() === 'AUTH_LAB') {
      this.getAuthorizationLabList(filterPayload);
    }
    else if (this.componentType.toLocaleUpperCase() === 'AUTH_RAD') {
      this.getAuthorizationRadList(filterPayload);
    }
  }

  public ifAuthcheck(): { id: string, name: string }[] {
    if (this.componentType.toLocaleUpperCase() === 'PRE_RAD') {
      return this.statusArray;
    }
    else if (this.componentType.toLocaleUpperCase() === 'PRE_LAB') {
      return this.statusArray;
    }
    else if (this.componentType.toLocaleUpperCase() === 'AUTH_LAB') {
      return this.statusArrayOnAuth;
    }
    else if (this.componentType.toLocaleUpperCase() === 'AUTH_RAD') {
      return this.statusArrayOnAuth;
    }
    else {
      return this.statusArray;
    }
  }


  public resetFilter(): void {
    this.prescriptionFilterForm.reset();
    this.page_limit = 10;
    this.page_no = 1;
    this.totalCount = 1;
    this.showNavigation = false;
    this.showAdvancedFilter = false;
    this.isInsideAdvacedContainer = false;
    this.userTypeListing();
  }

  public onAdvancedClick(event: MouseEvent): void {
    event?.stopPropagation();
    this.showAdvancedFilter = !this.showAdvancedFilter;
  }

  public onInsideAdvanceContainerClick(): void {
    this.isInsideAdvacedContainer = true;
  }

  public closeAdvanceFilter(controlName: string): void {
    this.prescriptionFilterForm.controls[controlName].reset();
    this.isScrollIntoViewNeeded();
    this.userTypeListing();
  }

  private isScrollIntoViewNeeded(): void {
    setTimeout(() => {
      this.focusedElement.last?.nativeElement.scrollIntoView();
    }, 100);
  }

  public showPrescriptionDetailsPopup(item: TransactionListByClient): void {
    this.viewPop.emit(
      {
        showPrescriptionDetails: true,
        batchId: item?.requestId,
        requestBatchId: item?.requestBatchId
      })
  }

  public currentPageDetail(event: { button_no: number, item_per_page: number }): void {
    if (event) {
      this.page_no = event.button_no;
      this.page_limit = event.item_per_page;
    }
    this.isScrollIntoViewNeeded();
    this.userTypeListing();
  }

  private preRadApiCall(filterPayload: Record<string, string | number | null>): void {
    this.toasterandLoader.isLoaderEnable(true);
    this.prescriptionService.getTransactionListRad(filterPayload, 1).subscribe({
      next: (list) => {
        this.transactionListByClient = list.data.data;
        this.totalCount = list?.data?.total;
        if (!this.transactionListByClient.length) this.showNavigation = true;
        this.toasterandLoader.isLoaderEnable(false);
      },
      error: (err) => {
        this.toasterandLoader.isLoaderEnable(false);
      },
    });
  }

  private preLabApiCall(filterPayload: Record<string, string | number | null>): void {
    this.toasterandLoader.isLoaderEnable(true);
    this.prescriptionService.getTransactionListLab(filterPayload, 1).subscribe({
      next: (list) => {
        this.transactionListByClient = list.data.data;
        this.totalCount = list?.data?.total;
        if (!this.transactionListByClient.length) this.showNavigation = true;
        this.toasterandLoader.isLoaderEnable(false);
      },
      error: (err) => {
        this.toasterandLoader.isLoaderEnable(false);
      }
    });
  }

  private getAuthorizationLabList(filterPayload: Record<string, string | number | null>): void {
    this.toasterandLoader.isLoaderEnable(true);
    this.authorizationService.getPreApprovalLabList(1, filterPayload).subscribe({
      next: (list) => {
        this.transactionListByClient = list.data.data;
        if (!this.transactionListByClient.length) this.showNavigation = true;
        this.totalCount = list?.data?.total;
        this.toasterandLoader.isLoaderEnable(false);
      }, error: (error) => {
        this.toasterandLoader.isLoaderEnable(false);
      }
    });
  };

  private getAuthorizationRadList(filterPayload: Record<string, string | number | null>): void {
    this.toasterandLoader.isLoaderEnable(true);
    this.authorizationService.getPreApprovalRadList(1, filterPayload).subscribe({
      next: (list) => {
        this.transactionListByClient = list.data.data;
        if (!this.transactionListByClient.length) this.showNavigation = true;
        this.totalCount = list?.data?.total;
        this.toasterandLoader.isLoaderEnable(false);
      }, error: (error) => {
        this.toasterandLoader.isLoaderEnable(false);
      }
    });
  };

  public setFeildName(feild: string): string {
    if (this.componentType.toLocaleUpperCase() === 'PRE_LAB' || this.componentType.toLocaleUpperCase() === 'AUTH_LAB') {
      return `Lab ${feild}`
    } else {
      return `Rad ${feild}`
    }
  }

  private Export(): void {
    let filterPayload = {
      sort: this.sortParams,
      requestId: this.prescriptionFilterForm?.value?.requestId || '',
      senderId: this.prescriptionFilterForm?.value?.senderId || '',
      receiverId: this.prescriptionFilterForm?.value?.receiverId || '',
      payerId: this.prescriptionFilterForm?.value?.payerId || '',
      memberId: this.prescriptionFilterForm?.value?.memberId || '',
      facilityId: this.prescriptionFilterForm?.value?.documentID || '',
      healthId: this.prescriptionFilterForm?.value?.healthId || '',
      prescriptionId: this.prescriptionFilterForm?.value?.prescriptionId || '',
      providerId: this.prescriptionFilterForm?.value?.providerId || '',
      approvalStatus: this.prescriptionFilterForm?.value?.status || '',
      iProviderType: (this.componentType == 'PRE_LAB' || this.componentType == 'AUTH_LAB') ? 1 : 2,
      iIsApprovalRequired: this.componentType == 'AUTH_RAD' ? 1 : (this.componentType == 'AUTH_LAB' ? 1 : null)

    }
    this.prescriptionService.exportList(filterPayload)
      .pipe().subscribe({
        next: (response) => {
          this.utility.download(response, this.utility.downloadTypes.excel)
        },
        error: (error) => {
          this.toasterandLoader.alert.toast({
            title: 'Error',
            type: 'error',
            message: error.message
          });
        }
      });
  }
}
